import React from "react";
import moment from "moment/moment";
import Pagination from "../utils/Pagination";
import { handleItemsPerPageChange, handlePageChange } from "../utils/PaginationUtilities";

export default function Schedule({ schedules, totalData, currentPage, itemsPerPage }) {
    const getDate = (date) => moment(date).format("Do MMM YY HH:MM");

    return (
        <div className="container">
            <div className="row">
                <div className="accordion" id="accordionExample">
                    <div className="col-sm-12 text-capitalize">
                        {schedules?.length > 0 ? (
                            schedules?.map((el, index) => (
                                <div className="accordion-item my-2" key={index}>
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button d-flex justify-content-between align-items-center"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${index}`}
                                            aria-expanded={el.isactive}
                                        >
                                            <div className="d-flex flex-column flex-md-row align-items-md-center w-100 justify-content-between">
                                                {/* Title */}
                                                <div className="fw-bold">{el.title}</div>

                                                {/* Status Badge */}
                                                <span
                                                    className={`badge rounded-pill px-3 py-2 ${
                                                        el.status === true
                                                            ? "bg-success"
                                                            : "bg-danger"
                                                    }`}
                                                    style={{ fontSize: "0.7rem" }}
                                                >
                                                    {el.status === true ? "Active" : "Removed"}
                                                </span>

                                                {/* Posted Info */}
                                                <div className="text-muted fs-6 mt-2 mt-md-0">
                                                    <span className="me-3 ms-3">
                                                        Posted By: {el?.trainerId?.name || "Unknown"}
                                                    </span>
                                                    Posted {getDate(el.PostedAt)}
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse${index}`}
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body">
                                            {el?.topics?.map((topic, topicIndex) => (
                                                <div key={topicIndex} className="mb-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={topic.isCompleted}
                                                        readOnly
                                                        className="form-check-input me-2"
                                                    />
                                                    {topic.topictitle}
                                                    <ul>
                                                        {topic.history.map((entry, index) => (
                                                            <li key={index}>
                                                                {`Moved from "${entry.fromScheduleId?.title}" (${getDate(
                                                                    entry.fromScheduleId?.createdAt
                                                                )}) to "${entry.toScheduleId?.title}" (${getDate(
                                                                    entry.toScheduleId?.createdAt
                                                                )}) on ${new Date(
                                                                    entry.movedAt
                                                                ).toLocaleString()}`}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <h1>No Schedule Present!!</h1>
                        )}
                    </div>
                </div>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-end">
                <Pagination
                    count={totalData}
                    page={currentPage}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
            </div>
        </div>
    );
}
